export default function Dumbell({ color = "#3E3E3E", width = "24", height = "24" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6482 8.15381L15.8459 10.3515L10.3511 15.8462L8.15345 13.6485L13.6482 8.15381Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.74723 11.5601C5.1112 11.1962 5.7013 11.1962 6.06527 11.5601L12.4396 17.9345C12.8036 18.2985 12.8036 18.8886 12.4396 19.2525L12.1094 19.5827C11.7455 19.9467 11.1554 19.9467 10.7914 19.5827L4.41703 13.2084C4.05306 12.8444 4.05306 12.2543 4.41703 11.8903L4.74723 11.5601Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.74747 14.8575C5.11144 14.4935 5.70155 14.4935 6.06552 14.8575L9.14338 17.9354C9.50735 18.2993 9.50735 18.8895 9.14338 19.2534L8.81318 19.5836C8.44921 19.9476 7.8591 19.9476 7.49514 19.5836L4.41727 16.5058C4.0533 16.1418 4.0533 15.5517 4.41727 15.1877L4.74747 14.8575Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2525 12.4406C18.8886 12.8046 18.2985 12.8046 17.9345 12.4406L11.5601 6.06623C11.1962 5.70226 11.1962 5.11215 11.5601 4.74819L11.8903 4.41799C12.2543 4.05402 12.8444 4.05402 13.2084 4.41799L19.5827 10.7923C19.9467 11.1563 19.9467 11.7464 19.5827 12.1104L19.2525 12.4406Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2528 9.14273C18.8888 9.5067 18.2987 9.5067 17.9347 9.14273L14.8569 6.06487C14.4929 5.7009 14.4929 5.11079 14.8569 4.74682L15.1871 4.41663C15.551 4.05266 16.1411 4.05266 16.5051 4.41663L19.583 7.49449C19.9469 7.85846 19.9469 8.44857 19.583 8.81254L19.2528 9.14273Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
